import React from "react";
import { DownloadExcelReport } from "../reusableComponent";
import { SearchInMis } from "../reusableComponent/search/serachForMisSection";
import StateSummaryFilter from "./stateSummaryFilter";

function MisHeader({
  isLoading,
  downloadLink,
  onClearDownload,
  onStartDownloading,
  totalItem,
  title,
  activeReport,
  callAfterDebounce,
  onSearch,
  onSelectingFilter,
  onOpenOfModal,
  onOpenOfProjectSummaryModal,
  onstateValueChange,
  chipResetCount
}) {
  const onOpenOfIssueModal = (
    modalState,
    previousFilterCount,
    currentFilterCount
  ) => {
    onOpenOfModal(modalState, previousFilterCount, currentFilterCount);
  };

  const projectSummaryModal = (
    projectModalState,
    previousFilterCount,
    currentFilterCount
  ) => {
    onOpenOfProjectSummaryModal(
      projectModalState,
      previousFilterCount,
      currentFilterCount
    );
  };

  const selectedmeetingType = JSON.parse(localStorage.getItem("meetingType"));
  const valueChange = offset => {
    onstateValueChange(offset);
  };

  return (
    <div
      className="mis-header"
      style={{
        marginBottom: activeReport === "MINISTRY_COMPLIANCE" ? 0 : 36,
        alignItems: title === "Nodal Officer Report" ? "normal" : "center"
      }}
    >
      {activeReport === "MEETINGS_SUMMARY" ? (
        <div className="d-flex align-items-center issue-main-container">
          <h3 className="m-0 issue-main-title">{title}</h3>
        </div>
      ) : (
        <div className="d-flex align-items-center issue-main-container">
          <h3 className="m-0 issue-main-title">{title}</h3>
          <span>({totalItem})</span>
        </div>
      )}

      <div className="issue-list-exposed-filters search-in-user p-0">
        {activeReport === "STATE_SUMMARY" ||
        activeReport === "MEETINGS_SUMMARY" ? (
          <div
            className="filters-sections m-0 w-full"
            style={{ position: "relative", right: "-15px" }}
          >
            <StateSummaryFilter
              activeReport
              selectedmeetingType={selectedmeetingType}
              onstateValueChange={valueChange}
              chipResetCount={chipResetCount}
              key={"stateSummary" + chipResetCount}
            />
          </div>
        ) : (
          ""
        )}

        {(isSearchBarActive(activeReport) && (
          <div
            className="issue-list-filter-right w-330"
            style={{ width: "330px" }}
          >
            {}

            <div className="filters-sections m-0 w-full">
              <SearchInMis
                placeholder="Search"
                callAfterDebounce={callAfterDebounce}
                keyName="search"
                onChange={onSearch}
                isSearchingIssue={isFilterActive(activeReport)}
                isFromMisSection={true}
                activeReport={activeReport}
                onOpenOfModal={onOpenOfIssueModal}
                onOpenOfProjectSummaryModal={projectSummaryModal}
              />
            </div>
          </div>
        )) ||
          null}
        {activeReport === "STATE_SUMMARY" ||
        activeReport === "MEETINGS_SUMMARY" ||
        activeReport === "MINISTRY_COMPLIANCE" ? null : (
          <DownloadExcelReport
            isLoading={isLoading}
            downloadLink={downloadLink}
            onClearDownload={onClearDownload}
            onStartDownloading={onStartDownloading}
          />
        )}
      </div>
    </div>
  );
}

function isFilterActive(activeReport) {
  const reportList = ["FLAT_FILE", "PROJECT_SUMMARY"];
  return reportList.some(element => {
    if (element === activeReport) {
      return true;
    }
    return false;
  });
}

function isSearchBarActive(activeReport) {
  const reportList = [
    "FLAT_FILE",
    //"STATE_SUMMARY",
    "PROJECT_SUMMARY",
    "MINISTRY_REPORT",
    "ISSUE_STATE"
  ];
  return reportList.some(element => {
    if (element === activeReport) {
      return true;
    }
    return false;
  });
}

export { MisHeader };
